<div class="block">
  <div class="blockChild" *ngFor="let children of item.children; let i = index">
    <div [id]="getContainerId(i)" class="iframe-container"></div>
  </div>
</div>
